module.exports = __webpack_public_path__ + "img/blue-bottle.4ee14bac.png";